import type { Blur64ImageData } from 'blur64';
import Link from 'next/link';
import { Media } from '@/shared/ui/media';
import { Media as MediaType } from '@/shared/ui/media/types';
import './hero-banner.scss';

type HeroBannerSlideProps = MediaType & {
    isScrollable: boolean;
    isInView: boolean;
    priority: boolean;
    blurData?: Blur64ImageData;
};
export const HeroBannerSlide = ({
    link,
    isScrollable,
    isInView,
    blurData,
    url,
    priority,
    alt,
    posterUrl,
    unoptimized,
}: HeroBannerSlideProps) => {
    const Wrapper = link ? Link : 'div';
    return (
        <Wrapper
            className="hero-banner__slide"
            {...((link && {
                href: link.url,
                target: link.isOpenInNewTab ? '_blank' : undefined,
            }) as { href: string; target?: string })}
            data-testid="hero-banner-slide"
            data-scrollable={isScrollable}
            data-priority={priority}
        >
            <Media
                className="hero-banner__media"
                data={{ url, alt, posterUrl, link, unoptimized }}
                isInView={isInView}
                priority={priority}
                blurData={blurData}
            />
        </Wrapper>
    );
};
